export default function reducer(
  state = {
    cities: '',
  },
  action
) {
  switch (action.type) {
    case 'GET_CITIES_STARTED': {
      return { ...state, changingStatus: 'ongoing' };
    }
    case 'GET_CITIES_SUCCESS': {
      return {
        ...state,
        changingStatus: 'success',
        cities: action.payload,
      };
    }
    case 'GET_CITIES_FAILED': {
      return {
        ...state,
        changingStatus: 'failed',
        cities: action.payload,
      };
    }
    default: {
      return state;
    }
  }
}
